import { EnterOfSettlementsBalanceService } from "./../../../services/documents/EnterOfSettlementsBalanceService";
import React from "react";
import { IAppEntity } from "../../entities";
import { DocumentService } from "../../../services/documents/DocumentService";
import { CreateEnterOfSettlementsBalancesDto } from "../../../dtos/documents/EnterOfSettlementsBalances/CreateEnterOfSettlementsBalancesDto";
import { EnterOfSettlementsBalancesDetail } from "../../../components/Pages/Documents/EnterOfSettlementsBalances/EnterOfSettlementsBalancesDetail";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupEnterOfSettlementsBalances } from "../../../components/Shared/NewForms/NFLookupEnterOfSettlementsBalances";
import EnterOfSettlementsBalancesList from "../../../components/Pages/Documents/EnterOfSettlementsBalances/EnterOfSettlementsBalancesList";

export const EnterOfSettlementsBalances: IAppEntity = {
  entityType: "document",
  title: "Enter Of Settlements Balances",
  pluralTitle: "Enter of Settlements Balances",
  apiUrl: "EnterOfSettlementsBalances",
  apiEnum: ReferenceTypes.DocumentEnterOfSettlementsBalance,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(EnterOfSettlementsBalancesDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(EnterOfSettlementsBalancesList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupEnterOfSettlementsBalances, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () =>
    new EnterOfSettlementsBalanceService("EnterOfSettlementsBalances"),
  getEmptyModel: () => {
    const model: CreateEnterOfSettlementsBalancesDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: 0,
      documentNumber: "",
      documentDate: new Date(),
      createdDate: new Date(),
      enterOfSettlementsBalanceGoods: [],
    };
    return model;
  },
};
